/**
 * Scripts spécifiques à la page Foire aux Questions.
 */
// Importer les javascripts généraux
import "./main";
import BackToTop from "./modules/back-to-top";
// Instancier le bouton back to top
const backToTop = new BackToTop();
// Gérer le filtre de mots-clefs
class FiltreMotsClefs {
    formFiltreMotsClefs;
    ddFiltreMotsClefs;
    constructor() {
        console.log("Dans constructeur");
        // Mettre la main sur les éléments du filtre par mots-clefs
        this.ddFiltreMotsClefs = document.getElementById('filtre-mots-clefs');
        this.formFiltreMotsClefs = document.getElementById('form-filtre-mots-clefs');
        // Assigner les écouteurs
        this.assignerListeners();
    }
    assignerListeners() {
        console.log("Dans assignerListeners");
        this.ddFiltreMotsClefs.addEventListener('change', () => { this.filtrerMotsClefs(); });
    }
    filtrerMotsClefs() {
        console.log("Dans soumettre formulaire");
        // Soumettre le formulaire
        console.log(this.ddFiltreMotsClefs.value);
        this.formFiltreMotsClefs.submit();
    }
}
const filtreMotsClefs = new FiltreMotsClefs();
